<template>
  <div class="edit-habit-program">
    <div class="card card--white">
      <div class="card--container">
        <v-alert type="error" :value="displayError">
          {{ displayError }}
        </v-alert>
        <h-input type="text" required label="Name" v-model="aof.name" :disabled="readOnly"/>
        <h-input type="number" v-model="aof.daily_exercises" label="Number of exercises to randomly select" />
        <h-input type="checkbox" :label="labelAssignAll" v-model="aof.assign_all" />
        <h-input type="number" v-if="!aof.assign_all" v-model='aof.max_number_of_allowed_groups'
          label="Number of Allowed Areas Of Focus to Choose" :disabled="readOnly"/>
        <h-select
         :items="pulseSurveys"
         label="Pulse Survey"
         item-text="name"
         item-value="id"
         v-model="aof.pulse_survey"
         :disabled="readOnly"
         ></h-select>
        <div class="section">
          <h-btn @click="createTheme"
            color="primary"
            :disabled="readOnly">
            Save
          </h-btn>
          <h-btn color="red" flat v-if="aof.id && aof.owner == user.id" @click="destroy">Destroy</h-btn>
          <div v-if="readOnly">
            This is managed by Habit Tech.
          </div>
        </div>
      </div>
    </div>
    <modal v-if="errorMessage" @close="errorMessage=''">
      <div slot="body">{{errorMessage}}</div>
    </modal>
  </div>
</template>

<script>
import User from "@/services/api/authUser";
import dataStore from "@/services/api/store";
import snackbarHub from "@/services/hubs/snackbar";
import modal from "@/components/modal";

const COACH_PULSE_SURVEYS_STORE = "CoachPulseSurveys";
const COACH_HABIT_PROGRAMS_STORE = "CoachHabitPrograms";
export default {
  props: ["aof"],
  components: {
    modal
  },
  created() {
    dataStore.findAll(COACH_PULSE_SURVEYS_STORE).then(results => {
      this.pulseSurveys = results;
    });
  },
  data() {
    return {
      displayError: "",
      user: User,
      errorMessage: "",
      pulseSurveys: []
    };
  },
  methods: {
    createTheme() {
      this.displayError = "";
      if (!this.aof.name) {
        this.displayError = "Habit Programs require names";
        return;
      }
      this.$emit("saved", this.theme);
    },
    destroy() {
      dataStore
        .destroy(COACH_HABIT_PROGRAMS_STORE, this.aof.id)
        .then(() => {
          snackbarHub.update("Deleted");
          this.$router.push({ name: "HabitProgramList" });
        })
        .catch(({ response }) => {
          let msg;
          switch (response.status) {
            case 404:
              msg = "Habit Program not found";
              break;
            case 403:
              msg = "Only owners may delete Habit Programs";
              break;
            case 409:
              msg = "You have clients currently using this program. Move these clients to a different Habit Program to continue.";
              break;
            default:
              msg = "Hmm... something went wrong. Our staff has been notified. Please try again later";
              break;
          }
          this.errorMessage = msg;
        });
    }
  },
  computed: {
    labelAssignAll() {
      if (this.aof.assign_all) {
        return "Assign All Areas of Focus";
      }
      return "Allow Clients to Choose Areas of Focus";
    },
    readOnly() {
      if (!this.aof.company && this.aof.id) {
        return true;
      }
      return false;
    }
  }
};
</script>

<style lang="less">
.edit-habit-program {
  .flex-row {
    display: flex;
    flex-direction: row;
    align-items: center;
  }
}
</style>
